@if (changes()) {
  <div
    data-testid="kpi-reference"
    class="gx-segmented p-px"
    role="group"
    [attr.aria-label]="'features.plan.panel.kpis.reference' | translate">
    <button
      type="button"
      data-testid="kpi-reference-saved"
      class="seg px-1.5 py-px text-[10.5px] focus-visible:shadow-[var(--shadow-focus)]"
      [class.is-active]="reference() === 'saved'"
      [attr.aria-pressed]="reference() === 'saved'"
      (click)="panel.kpiReference.set('saved')">
      {{ 'features.plan.panel.kpis.vs_saved' | translate }}
    </button>
    <button
      type="button"
      data-testid="kpi-reference-before"
      class="seg px-1.5 py-px text-[10.5px] focus-visible:shadow-[var(--shadow-focus)] disabled:cursor-not-allowed disabled:opacity-50"
      [class.is-active]="reference() === 'before'"
      [attr.aria-pressed]="reference() === 'before'"
      [disabled]="!hasRound()"
      (click)="panel.kpiReference.set('before')">
      {{ 'features.plan.panel.kpis.vs_last_change' | translate }}
    </button>
  </div>
}
<app-kpi-picker [available]="available()" />
